let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4UXsQ")).then(() => parcelRequire('g8lYr'));